import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import columns from "./Table/columns";

import { useContext } from "../Context";

export default function Table() {
  const { dispatch, actions, state } = useContext();

  return (
    <div className="datatable-style">
      <DataTable
        title=""
        columns={columns}
        data={state.policy.attributes.documents || []}
        noDataComponent={<div className="mt20">No matching records found</div>}
        persistTableHead={true}
        pagination
        paginationComponentOptions={{
          selectAllRowsItem: true,
          selectAllRowsItemText: "All",
        }}
      />
    </div>
  );
}
